import ClientSearchModalNew from './ClientSearchModalNew.container';

export default ClientSearchModalNew;
